import React from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  HeadingText,
  BodyText,
} from '@paypalcorp/pp-react';
import { v2grey50, v2blue700 } from '@paypalcorp/pp-react-colors';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import style from './promoMessage.less';

const PromoMessage = ({
  size = 'lg',
  header,
  headerSize,
  subHeader,
  CTAText,
  CTAUrl,
  imageUrl,
  imagePosition,
  hasImageOffset,
  backgroundColor,
  promoContainerOffset,
  imageProps,
  mobileImagePosition,
  onClick,
  isDarkBackground,
  isTertiaryButton,
}) => {
  const headerComponent = (
    <Col className={style.textColumn} sm={6} xs={12}>
      <div className={style.headerContainer}>
        <HeadingText
          size={headerSize}
          style={{
            color: isDarkBackground ? v2grey50 : v2blue700,
            marginBottom: '10px',
          }}
        >
          {header}
        </HeadingText>
        <BodyText style={{ color: isDarkBackground ? v2grey50 : v2blue700 }}>
          {subHeader}
        </BodyText>
        <Button
          className={style.promoMessageButton}
          style={{
            color: isTertiaryButton && isDarkBackground ? v2grey50 : '',
          }}
          as='a'
          href={CTAUrl}
          role='button'
          onClick={onClick}
          inverse={isDarkBackground}
          tertiary={isTertiaryButton}
        >
          {CTAText}
        </Button>
      </div>
    </Col>
  );

  const imgComponent = (
    <Col
      sm={6}
      xs={12}
      className={
        hasImageOffset
          ? `${style.topOffset} ${style.imageColumn}`
          : style.imageColumn
      }
    >
      <img
        alt='bannerImg'
        src={imageUrl}
        className={style.promoImage}
        height={imageProps && imageProps.height}
        width={imageProps && imageProps.width}
      />
    </Col>
  );

  let classNames = [style.parentPromoContainer];
  if (promoContainerOffset) {
    classNames.push(style.promoContainerOffset);
  }
  if (size === 'sm') {
    classNames.push(style.smallSize);
  }

  return (
    <Container
      fluid={true}
      style={{ backgroundColor }}
      className={classNames.join(' ')}
    >
      <Container className={style.promoMessageContainer}>
        <MediaQuery maxWidth={480}>
          <Row noGutters={true}>
            {imageProps && imageProps.mobilePosition === 'bottom'
              ? [headerComponent, imgComponent]
              : [imgComponent, headerComponent]}
          </Row>
        </MediaQuery>

        <MediaQuery minWidth={481}>
          <Row noGutters={true}>
            {imagePosition === 'left'
              ? [imgComponent, headerComponent]
              : [headerComponent, imgComponent]}
          </Row>
        </MediaQuery>
      </Container>
    </Container>
  );
};

PromoMessage.propTypes = {
  size: PropTypes.string,
  header: PropTypes.string.isRequired,
  headerSize: PropTypes.string,
  subHeader: PropTypes.string.isRequired,
  CTAText: PropTypes.string.isRequired,
  CTAUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imagePosition: PropTypes.string,
  hasImageOffset: PropTypes.bool,
  backgroundColor: PropTypes.string,
  promoContainerOffset: PropTypes.bool,
  imageProps: PropTypes.object,
  onClick: PropTypes.func,
};

PromoMessage.defaultProps = {
  size: 'lg',
  headerSize: 'lg',
  imagePosition: 'right',
  hasImageOffset: false,
  backgroundColor: '#FFE888',
  promoContainerOffset: false,
  isTertiaryButton: false,
};

export default PromoMessage;
